module.exports = __webpack_public_path__ + "545e4872b8e0b75d10656bbc2f36b343.svg";